export default "__VITE_ASSET__CsFhzDzF__"